import { useEffect, useState } from "react"
import { Report } from "../../interfaces/intakes.reports"
import { PDF_STEPS_CONTACTS } from "../pdf/PDF_STEPS_CONTACTS"
import { TempContact } from "./ModalSendPDF"
import { v4 as uuidv4 } from 'uuid';
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { PDF_STEPS_EMAIL } from "../pdf/PDF_STEPS_EMAIL";

interface Props {
    report: Report
    closeModal: () => void
}
export const ModalSharePDF = ({ report, closeModal }: Props) => {

    const [step, setStep] = useState<number>(1)
    const [prevMailTo, setPrevMailTo] = useState<TempContact[]>([])
    const [prevCcTo, setPrevCcTo] = useState<TempContact[]>([])
    const { email } = useTypedSelector(state => state.auth)


    useEffect(() => {
        if (report.team === "64bf420fd230431df3d2af73") {
            setPrevCcTo([{
                id: uuidv4(),
                check: true,
                name: "Quality GP",
                email: "quality@growerspackers.com"
            }])
        }
    }, [email, report.team])

    return (
        <div className="modal">

            <div className="modal__cardPDF">

                {
                    step === 1 &&
                    <PDF_STEPS_CONTACTS report={report} setMailTo={setPrevMailTo} mailTo={prevMailTo} next={() => setStep(step => step + 1)} closeModal={closeModal} />
                }

                {
                    step === 2 &&
                    <PDF_STEPS_EMAIL
                        reportId={report._id}
                        pdf={report.pdf || ""}
                        mainData={report.mainData}
                        date={report.date}
                        prevMailTo={prevMailTo}
                        prevCcTo={prevCcTo}
                        closeModal={closeModal}
                        previous={() => setStep(step => step - 1)}
                    />
                }

            </div>
        </div>
    )
}
